export default {
  text: '轮播图组件',
  // 在低代码平台展示的组件名称
  icon: 'http://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202310/27/9f502_20231027161718.png',
  // 在低代码平台展示的组件图标
  name: 'SmSwiper',
  // 固定
  group: '活动组件（仅此组件支持小程序）',
  sort: 2,
  // 排序
  schema: {
    /* 该配置用于描述该组件 */
    type: 'object',
    // 固定
    widget: 'SmSwiper',
    // 该组件唯一标记，需要和导出组件名称一致，重要
    category: 'swiper',
    // 轮播类型，tabs可以控制轮播
    containerType: 'template',
    // 固定
    properties: {} // 固定
  },
  setting: {
    /* 该配置用于低代码平台右侧的属性配置 */
    props: {
      widget: 'MEH5MediaSwiperSettingWidget',
      type: 'object'
    }
  }
};